import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

/**
 * Получить название валюты с учётом количества (plural)
 * @param {number} count - количество
 * @param {object} options - дополнительные опции (например, short)
 * @returns {string}
 */
export function getCurrencyName(count = 1, options = {}) {
	if (options.short) {
		return i18n.t('currency.short');
	}
	return i18n.t('currency', { count });
}

// React-хук
export function useCurrencyName(count = 1, options = {}) {
	const { t } = useTranslation();
	if (options.short) {
		return t('currency.short');
	}
	return t('currency', { count });
} 